import { render, staticRenderFns } from "./OpenSessionDetailModal.vue?vue&type=template&id=844680fa&scoped=true&"
import script from "./OpenSessionDetailModal.vue?vue&type=script&lang=js&"
export * from "./OpenSessionDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./OpenSessionDetailModal.vue?vue&type=style&index=0&id=844680fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844680fa",
  null
  
)

export default component.exports